import type { WantedSubmissionStatus } from "./wantedStatus";

export const wantedEditorStates = [
  "draft",
  "saved",
  "dirty",
  "submitted",
  "closed",
  "unavailable",
] as const;

export type WantedEditorState = (typeof wantedEditorStates)[number];

type WantedEditorStateInput = {
  readonly submissionStatus: WantedSubmissionStatus;
  readonly hasSavedDraft: boolean;
  readonly hasUnsavedChanges: boolean;
};

export function getWantedEditorState({
  submissionStatus,
  hasSavedDraft,
  hasUnsavedChanges,
}: WantedEditorStateInput): WantedEditorState {
  if (submissionStatus === "closed") return "closed";
  if (submissionStatus === "submitted") return "submitted";
  if (submissionStatus === "empty") return "unavailable";
  if (hasUnsavedChanges) return "dirty";
  return hasSavedDraft ? "saved" : "draft";
}

export const wantedEditorStatePresentation: Record<
  WantedEditorState,
  { readonly label: string; readonly description: string }
> = {
  draft: {
    label: "작성 중",
    description: "변경한 내용은 아직 서버에 저장되지 않았습니다.",
  },
  saved: {
    label: "임시저장됨",
    description: "내용을 계속 수정하거나 제출할 수 있습니다.",
  },
  dirty: {
    label: "임시저장 이후 변경사항 있음",
    description: "임시저장하면 현재 변경사항을 서버에 보관합니다.",
  },
  submitted: {
    label: "제출 완료",
    description: "마감 전에는 제출을 철회한 뒤 수정할 수 있습니다.",
  },
  closed: {
    label: "마감 완료",
    description: "마감된 원티드는 수정, 철회, 삭제할 수 없습니다.",
  },
  unavailable: {
    label: "신청 기간 없음",
    description: "현재 작성 가능한 원티드 기간이 없습니다.",
  },
};
